import appComponentVersions from './schemas/appComponentVersions/schema.json'
import appState from './schemas/appState/schema.json'
import editorFeatures from './schemas/editorFeatures/schema.json'
import fragmentIndex from './schemas/fragmentIndex/schema.json'
import siteContext from './schemas/siteContext/schema.json'
import dependsOnNamespace from './namespaces/dependsOn.json'
import dependedByNamespace from './namespaces/dependedBy.json'

const schemas = {
    AppComponentVersions: appComponentVersions,
    AppState: appState,
    EditorFeatures: editorFeatures,
    FragmentIndex: fragmentIndex,
    SiteContext: siteContext
}

const dependencyNamespaces = {
    dependsOn: dependsOnNamespace,
    dependedBy: dependedByNamespace
}

// todo: remove this export when we have a system to save and retrieve schemas
export {schemas, dependencyNamespaces}
